import {Injectable} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {MatIconRegistry} from '@angular/material/icon';

@Injectable({
  providedIn: 'root',
})
export class IconRegistryService {
  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) {}

  icons = [
    {name: 'activity', path: '../assets/img/icons/universal/activity.svg'},
    {name: 'alert-triangle', path: '../assets/img/icons/universal/alert-triangle.svg'},
    {name: 'auto-sked', path: '../assets/img/icons/universal/auto-sked.svg'},
    {name: 'basketball', path: '../assets/img/icons/universal/basketball.svg'},
    {name: 'bell', path: '../assets/img/icons/universal/bell-2.svg'},
    {name: 'billing', path: '../assets/img/icons/universal/billing.svg'},
    {name: 'book', path: '../assets/img/icons/universal/book.svg'},
    {name: 'book-open', path: '../assets/img/icons/universal/book-open.svg'},
    {name: 'bolt', path: '../assets/img/icons/universal/bolt.svg'},
    {name: 'box', path: '../assets/img/icons/universal/box.svg'},
    {name: 'briefcase', path: '../assets/img/icons/universal/briefcase.svg'},
    {name: 'bucket', path: '../assets/img/icons/builder/project-builder/task-icons/bucket.svg'},
    {name: 'calendar', path: '../assets/img/icons/universal/calendar.svg'},
    {name: 'calendar-filled', path: '../assets/img/icons/universal/calendar_filled.svg'},
    {name: 'chain', path: '../assets/img/icons/chain.svg'},
    {name: 'check', path: '../assets/img/icons/universal/check.svg'},
    {name: 'check-white-bg', path: '../assets/img/icons/check-white-bg.svg'},
    {name: 'checkbox-centered', path: '../assets/img/icons/universal/checkbox-centered.svg'},
    {name: 'check-2', path: '../assets/img/icons/universal/check-2.svg'},
    {name: 'checkbox-check', path: '../assets/img/icons/universal/checkbox-check.svg'},
    {name: 'check-square', path: '../assets/img/icons/universal/check-square.svg'},
    {name: 'chevron-down', path: '../assets/img/icons/universal/chevron-down.svg'},
    {name: 'chevron-left', path: '../assets/img/icons/universal/chevron-left.svg'},
    {name: 'chevron-right', path: '../assets/img/icons/universal/chevron-right.svg'},
    {name: 'chevron-up', path: '../assets/img/icons/universal/chevron-up.svg'},
    {name: 'clock', path: '../assets/img/icons/universal/clock.svg'},
    {name: 'clock-thin', path: '../assets/img/icons/universal/clock-thin.svg'},
    {name: 'clock-fill', path: '../assets/img/icons/universal/icon-clock-fill.svg'},
    {name: 'close', path: '../assets/img/icons/universal/close.svg'},
    {name: 'coin-amber', path: '../assets/img/icons/coins/coin-amber.svg'},
    {name: 'coin-amethyst', path: '../assets/img/icons/coins/coin-amethyst.svg'},
    {name: 'coin-emerald', path: '../assets/img/icons/coins/coin-emerald.svg'},
    {name: 'coin-golden', path: '../assets/img/icons/coins/coin-golden.svg'},
    {name: 'coin-silver', path: '../assets/img/icons/coins/coin-silver.svg'},
    {name: 'coin-quartz', path: '../assets/img/icons/coins/coin-quartz.svg'},
    {name: 'coin-sapphire', path: '../assets/img/icons/coins/coin-sapphire.svg'},
    {name: 'columns', path: '../assets/img/icons/universal/columns.svg'},
    {name: 'dashboard', path: '../assets/img/icons/universal/dashboard.svg'},
    {name: 'drag-handler', path: '../assets/img/icons/drag_handler.svg'},
    {name: 'dollar-sign', path: '../assets/img/icons/universal/dollar-sign.svg'},
    {name: 'dribbble', path: '../assets/img/icons/universal/dribbble.svg'},
    {name: 'family', path: '../assets/img/icons/universal/family.svg'},
    {name: 'feather', path: '../assets/img/icons/universal/feather.svg'},
    {name: 'fish', path: '../assets/img/icons/builder/project-builder/task-icons/fish.svg'},
    {name: 'grid', path: '../assets/img/icons/builder/project-builder/task-icons/grid.svg'},
    {name: 'heart', path: '../assets/img/icons/universal/heart.svg'},
    {name: 'house', path: '../assets/img/icons/universal/house.svg'},
    {name: 'info', path: '../assets/img/icons/universal/info.svg'},
    {name: 'info-i', path: '../assets/img/icons/info-i.svg'},
    {name: 'key', path: '../assets/img/icons/universal/key.svg'},
    {name: 'leaf', path: '../assets/img/icons/builder/project-builder/task-icons/leaf.svg'},
    {name: 'lenses', path: '../assets/img/icons/universal/lenses.svg'},
    {name: 'logout', path: '../assets/img/icons/universal/logout.svg'},
    {name: 'mag', path: '../assets/img/icons/builder/project-builder/task-icons/mag.svg'},
    {name: 'map-pin', path: '../assets/img/icons/universal/map-pin.svg'},
    {name: 'map-pin-fill', path: '../assets/img/icons/universal/icon-pin-fill.svg'},
    {name: 'minus', path: '../assets/img/icons/universal/minus.svg'},
    {name: 'mission', path: '../assets/img/icons/mission.svg'},
    {name: 'move', path: '../assets/img/icons/universal/move.svg'},
    {name: 'nut', path: '../assets/img/icons/universal/nut.svg'},
    {name: 'palette', path: '../assets/img/icons/builder/project-builder/task-icons/palette.svg'},
    {name: 'pencil', path: '../assets/img/icons/builder/project-builder/task-icons/pencil.svg'},
    {name: 'pencil-outline', path: '../assets/img/icons/universal/pencil.svg'},
    {name: 'plant', path: '../assets/img/icons/universal/plant.svg'},
    {name: 'plus', path: '../assets/img/icons/universal/plus.svg'},
    {name: 'project', path: '../assets/img/icons/universal/project.svg'},
    {name: 'project-viewer', path: '../assets/img/icons/universal/project-viewer.svg'},
    {name: 'rabbit', path: '../assets/img/icons/universal/rabbit.svg'},
    {name: 'reporting', path: '../assets/img/icons/universal/reporting.svg'},
    {name: 'rewards', path: '../assets/img/icons/universal/rewards.svg'},
    {name: 'search', path: '../assets/img/icons/universal/search.svg'},
    {name: 'settings', path: '../assets/img/icons/universal/settings.svg'},
    {name: 'sked-list', path: '../assets/img/icons/universal/sked.svg'},
    {name: 'smile', path: '../assets/img/icons/universal/smile.svg'},
    {name: 'sort-arrow', path: '../assets/img/icons/universal/sort-arrow.svg'},
    {name: 'subtask', path: '../assets/img/icons/subtask.svg'},
    {name: 'star', path: '../assets/img/icons/universal/star.svg'},
    {name: 'target', path: '../assets/img/icons/universal/target.svg'},
    {name: 'thermometer', path: '../assets/img/icons/builder/project-builder/task-icons/thermometer.svg'},
    {name: 'token', path: '../assets/img/icons/universal/token.svg'},
    {name: 'tracker', path: '../assets/img/icons/universal/tracker.svg'},
    {name: 'trello', path: '../assets/img/icons/universal/trello.svg'},
    {name: 'plus-white', path: '../assets/img/icons/plus_white.svg'},
    {name: 'user', path: '../assets/img/icons/universal/user.svg'},
    {name: 'users', path: '../assets/img/icons/universal/users.svg'},
    {name: 'walk', path: '../assets/img/icons/builder/project-builder/task-icons/walk.svg'},
    {name: 'x', path: '../assets/img/icons/universal/x.svg'},
    {name: 'x-circle', path: '../assets/img/icons/universal/x-circle.svg'},
    {name: 'x-brown', path: '../assets/img/icons/x-brown.svg'},
    {name: 'cv-task', path: '../assets/img/icons/challenge-viewer/cv-task.svg'},
    {name: 'cv-milestone', path: '../assets/img/icons/challenge-viewer/cv-milestone.svg'},
    {name: 'cv-salvage', path: '../assets/img/icons/challenge-viewer/cv-salvage.svg'},
    {name: 'cv-alert', path: '../assets/img/icons/challenge-viewer/cv-alert.svg'},
    {name: 'cv-task', path: '../assets/img/icons/challenge-viewer/cv-task.svg'},
    {name: 'cv-task', path: '../assets/img/icons/challenge-viewer/cv-task.svg'},
  ];

  registerIcons() {
    this.icons.forEach(icon => {
      this.matIconRegistry.addSvgIcon(icon.name, this.domSanitizer.bypassSecurityTrustResourceUrl(icon.path));
    });
  }
}
